/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Post_TitleInputs */

const en_label_post_title = /** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post Title`)
};

const es_label_post_title = /** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título de la Publicación`)
};

const fr_label_post_title = /** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre de l'article`)
};

const de_label_post_title = /** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitragstitel`)
};

const id_label_post_title = /** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul Postingan`)
};

/** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */
const ja_label_post_title = en_label_post_title;

/** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */
const zh_label_post_title = en_label_post_title;

/** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */
const ar_label_post_title = en_label_post_title;

/** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */
const it_label_post_title = en_label_post_title;

/** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */
const ru_label_post_title = en_label_post_title;

/** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */
const pt_label_post_title = en_label_post_title;

/** @type {(inputs: Label_Post_TitleInputs) => LocalizedString} */
const ko_label_post_title = en_label_post_title;

/**
* | output |
* | --- |
* | "Post Title" |
*
* @param {Label_Post_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_post_title = /** @type {((inputs?: Label_Post_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Post_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_post_title(inputs)
	if (locale === "es") return es_label_post_title(inputs)
	if (locale === "fr") return fr_label_post_title(inputs)
	if (locale === "de") return de_label_post_title(inputs)
	if (locale === "ja") return ja_label_post_title(inputs)
	if (locale === "zh") return zh_label_post_title(inputs)
	if (locale === "ar") return ar_label_post_title(inputs)
	if (locale === "id") return id_label_post_title(inputs)
	if (locale === "it") return it_label_post_title(inputs)
	if (locale === "ru") return ru_label_post_title(inputs)
	if (locale === "pt") return pt_label_post_title(inputs)
	return ko_label_post_title(inputs)
});